/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { RouterProps, showNotification } from '../App';
import { UserFeature, UserFeatureEnum } from '../types/UserFeature';
import GroupIcon from '@material-ui/icons/Group';
import BusinessIcon from '@material-ui/icons/Business';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import LookupTeamsMaintenance from './tabs/LookupTeamsMaintenance';
import LookupTeamMemberMaintenance from './tabs/LookupTeamMemberMaintenance';
import LookupOfficesMaintenance from './tabs/LookupOfficesMaintenance';
import LookupOfficeMemberMaintenance from './tabs/LookupOfficeMemberMaintenance';
import LookupDepartmentMaintenance from './tabs/LookupDepartmentMaintenance';
import LookupDepartmentMemberMaintenance from './tabs/LookupDepartmentMemberMaintenance';
import LookupUserAssistantMaintenance from './tabs/LookupUserAssistantMaintenance';
import LookupUserAssistantMemberMaintenance from './tabs/LookupUserAssistantMemberMaintenance';
import { client } from '..';
import { UserData } from '../configurationDashboard/ConfigurationDashboardPage';
import { LearnMoreEnum } from '../learnMore/LearnMorePage';
import { SkeletonLoader } from '../components/loading/SkeletonLoader';
import { FilteredVerticalTabPage, SidebarGroup, SidebarItem } from '../v2/layouts/FilteredVerticalTabPage';

export enum TableList {
    offices = 0,
    department,
    teams,
    userAssistant,
}

interface FirmStructureConfigurationPageState {
    selectedTable: TableList;
}

interface FirmStructureConfigurationPageProps extends RouterProps {

}

const groupStyles: { [key: string]: { iconBg: string; iconColor: string } } = {
    organisation: { iconBg: '#ccfbf1', iconColor: '#0f766e' },
    staff: { iconBg: '#e3f2fd', iconColor: '#1565c0' },
};

export default function FirmStructureConfigurationPage(props: FirmStructureConfigurationPageProps) {

    var routeTab: TableList = TableList[props.match.params.tab as keyof typeof TableList];

    const [pageState, setPageState] = useState<FirmStructureConfigurationPageState>({
        selectedTable: routeTab ? routeTab : TableList.department
    });

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isInternalAdmin, setIsInternalAdmin] = useState<boolean>(false);

    // tslint:disable-next-line: no-any
    let routeCommand = props.match.params.command;

    useEffect(() => {
        fetchAppUserData();
    // tslint:disable-next-line: align
    }, []);

    const fetchAppUserData = () => {
        client.query({
            query: UserData,
            fetchPolicy: 'network-only'
            // tslint:disable-next-line:no-any
        }).then((results: {
            // tslint:disable-next-line:no-any
            data: any;
            }) => {
                if (results.data.appUser) {
                    setIsInternalAdmin(results.data.appUser.isInternalAdmin);
                }
                setIsLoading(false);
            // tslint:disable-next-line: no-any
            }).catch((reason: any) => {
                showNotification(null, reason, 'error');
        });
    };

    const onClickBack = () => {
        props.history.push('/configurationDashboard');
    };

    const onClickTab = (value: TableList) => {
        setPageState({
            ...pageState,
            selectedTable: value
        });

        props.history.push(`/firmStructureConfiguration/${TableList[value]}`);
    };

    const onLearnMore = () => {
        props.history.push({
            pathname: `/learnMore/${LearnMoreEnum[LearnMoreEnum.FIRM_STRUCTURE]}`,
        });
    };

    const groups: SidebarGroup[] = [
        { key: 'organisation', label: 'Organisation', icon: <AccountTreeIcon />, iconColor: groupStyles.organisation.iconColor },
        { key: 'staff', label: 'Staff', icon: <PeopleOutlineIcon />, iconColor: groupStyles.staff.iconColor },
    ];

    const allSidebarItems: Array<SidebarItem & { hasAccess: boolean }> = [
        {
            id: TableList[TableList.department],
            name: 'Firm Departments',
            description: 'Departments in the firm',
            group: 'organisation',
            icon: <HomeWorkIcon fontSize="small" />,
            iconBg: groupStyles.organisation.iconBg,
            iconColor: groupStyles.organisation.iconColor,
            hasAccess: UserFeature.HasAccess(UserFeatureEnum.hasFirmDepartmentLookupMaintenance) || isInternalAdmin,
        },
        {
            id: TableList[TableList.offices],
            name: 'Firm Offices',
            description: 'Offices in the firm',
            group: 'organisation',
            icon: <BusinessIcon fontSize="small" />,
            iconBg: groupStyles.organisation.iconBg,
            iconColor: groupStyles.organisation.iconColor,
            hasAccess: UserFeature.HasAccess(UserFeatureEnum.hasFirmOfficeLookupMaintenance) || isInternalAdmin,
        },
        {
            id: TableList[TableList.teams],
            name: 'Firm Teams',
            description: 'Teams in the firm',
            group: 'organisation',
            icon: <GroupIcon fontSize="small" />,
            iconBg: groupStyles.organisation.iconBg,
            iconColor: groupStyles.organisation.iconColor,
            hasAccess: UserFeature.HasAccess(UserFeatureEnum.hasFirmTeamLookupMaintenance) || isInternalAdmin,
        },
        {
            id: TableList[TableList.userAssistant],
            name: 'User Assistant',
            description: 'Assistants for staff members.',
            group: 'staff',
            icon: <SupervisorAccountOutlinedIcon fontSize="small" />,
            iconBg: groupStyles.staff.iconBg,
            iconColor: groupStyles.staff.iconColor,
            hasAccess: UserFeature.HasAccess(UserFeatureEnum.hasUserAssistantLookupMaintenance) || isInternalAdmin,
        },
    ];

    const sidebarItems: SidebarItem[] = isLoading
        ? []
        : allSidebarItems
            .filter(item => item.hasAccess)
            .map(({ hasAccess, ...item }) => item);

    const onItemSelect = (item: SidebarItem) => {
        onClickTab(TableList[item.id as keyof typeof TableList]);
    };

    const renderContent = () => {
        if (isLoading) {
            return <SkeletonLoader variant="panel" columns={3} rows={4} />;
        }

        return (
            <>
                {(pageState.selectedTable === TableList.teams && routeCommand === undefined) && (<LookupTeamsMaintenance />)}
                {/* tslint:disable-next-line: max-line-length */}
                {(pageState.selectedTable === TableList.teams && routeCommand !== undefined) && (<LookupTeamMemberMaintenance {...props}/>)}
                {/* tslint:disable-next-line: max-line-length */}
                {(pageState.selectedTable === TableList.offices && routeCommand === undefined) && (<LookupOfficesMaintenance />)}
                {/* tslint:disable-next-line: max-line-length */}
                {(pageState.selectedTable === TableList.offices && routeCommand !== undefined) && (<LookupOfficeMemberMaintenance {...props}/>)}
                {/* tslint:disable-next-line: max-line-length */}
                {(pageState.selectedTable === TableList.department && routeCommand === undefined) && (<LookupDepartmentMaintenance />)}
                {(pageState.selectedTable === TableList.department
                    && routeCommand !== undefined) && (<LookupDepartmentMemberMaintenance {...props}/>)}
                {/* tslint:disable-next-line: max-line-length */}
                {(pageState.selectedTable === TableList.userAssistant && routeCommand === undefined) && (<LookupUserAssistantMaintenance />)}
                {(pageState.selectedTable === TableList.userAssistant
                    && routeCommand !== undefined) && (<LookupUserAssistantMemberMaintenance {...props}/>)}
            </>
        );
    };

    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            flexDirection="column"
        >
            <FilteredVerticalTabPage
                icon={<AccountTreeIcon fontSize="small" />}
                title="Firm Structure"
                subtitle="Maintain information relating to staff groups and structures"
                onBack={onClickBack}
                backTooltip="Back to configuration dashboard"
                onLearnMore={onLearnMore}

                enableSearch
                searchPlaceholder="Search firm structure…"

                sidebarGroups={groups}
                sidebarItems={sidebarItems}
                selectedId={TableList[pageState.selectedTable]}
                sidebarLoading={isLoading}
                onItemSelect={onItemSelect}

                renderContent={renderContent}
                sidebarWidth={340}
            />
        </Box>
    );
}
